import type { PrescriptionPadReviewAction } from '@/components/PatientPageV2/components/PrescriptionPad';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updatePrescriptionPadReviewAction: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (action: PrescriptionPadReviewAction) => void
> = (set) => (action) =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      const updatedActions = state.prescriptionAssistant.prescriptionPad.actions.map((actionItem) => {
        if (actionItem.id === action.id) {
          return action;
        }

        return actionItem;
      });
      state.prescriptionAssistant.prescriptionPad.actions = updatedActions;
    },
    false,
    'prescriptionPad/updatePrescriptionPadReviewAction'
  );
